import { forwardRef } from "react";
import { Typography, ITypographyProps } from "../Typography";

export interface IH1Props extends Omit<ITypographyProps, "as" | "variant"> {}

export const H1 = forwardRef<HTMLHeadingElement, IH1Props>((props, ref) => {
  return <Typography ref={ref} as="h1" variant="h1" {...props} />;
});

H1.displayName = "H1";
